import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[limitInputNum]',
})

export class LimitInputNum {

  constructor(private elementRef: ElementRef) {
    
  }
  
  @HostListener('window: keyup', ['$event']) onKeyUp() {  
    if (this.elementRef.nativeElement.value < 0 || this.elementRef.nativeElement.value == '') {
      this.elementRef.nativeElement.value = 0
    } else if (this.elementRef.nativeElement.value > 100) {
      this.elementRef.nativeElement.value = 100
    }   
  }

}


// WEBPACK FOOTER //
// ./src/app/views/campaign/new-campaign/step-3/triple-percentage-slider/limitInputNum.directive.ts